export const CAMPAIGN_SUCCESS = 'CAMPAIGN_SUCCESS'
export const CAMPAIGN_FAILURE = 'CAMPAIGN_FAILURE'

export const campaignData = (campaign) =>{
  return (dispatch, getState) => {
    dispatch({ type: CAMPAIGN_SUCCESS, campaign });
  }
}
